import React, { useState, useEffect } from "react";

import {Dialog} from "@material-ui/core";
import SearchInvoiceScreean from "./SearchInvoiceScreean";
const defaultAutos = {
  Branches: [],
};

export default function SearchInvoicesMains(props) {
  const {
    openDw,
    handCloseDw,
    transition,
    showChosedInv,
    invsShow,
    stElemnt,
    style,
    valueTypeFltr,
    gets,
    searchedInvShow,
    setOr,
    or,
    optionsCustomers,
    PcIdIvPc,
    setting,
    setIsClick,
    ished,
    AutoOptions,
    isHedden,
    permistionInv,
    setIshedden,
    isStock,
    isMake,
    isPurches,
    invsSearchTable,
    setInvsSearchTable,
    setValue,
    rptParamsSearch,
    setRptParamsSearch
  } = props;



  return (
    <Dialog
      fullScreen
      open={openDw}
      onClose={handCloseDw}
      TransitionComponent={transition}
      key={transition ? transition.name : ""}
    >
      <SearchInvoiceScreean
        {...{
          openDw,
          handCloseDw,
          transition,
          showChosedInv,
          invsShow,
          stElemnt,
          style,
          valueTypeFltr,
          gets,
          searchedInvShow,
          setOr,
          or,
          optionsCustomers,
          PcIdIvPc,
          setting,
          setIsClick,
          ished,
          AutoOptions,
          isHedden,
          permistionInv,
          setIshedden,
          isStock,
          isMake,
          isPurches,
          invsSearchTable,
          setInvsSearchTable,
          setValue,
          rptParamsSearch,
          setRptParamsSearch
        }}
      />
    </Dialog>

  );
}
